import { API_BASE_URL } from "src/config/api";
import React, { useEffect, useState } from 'react';
import {
  Button,
  DialogActions,
  TextField,
  Container,
  Card,
  Paper,
  Typography,
  Grid,
  CircularProgress,
  Box,
} from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import ConfirmationDialog from '../../../layouts/shared/ConfirmationDialog';

CustomizePlan.propTypes = {
  closeForm: PropTypes.func,
  reloadData: PropTypes.func,
};

function CustomizePlan({ closeForm, reloadData }) {
  const [formData, setFormData] = useState({
    subscriptionAmount: '',
    subscriptionDays: '',
    numberOfIp: '',
    numberOfDomain: '',
  });

  const [userId, setUserId] = useState(null);
  const [subsciptionPlanId, setSubscriptionPlanId] = useState(null);
  const [customPlanId, setCustomPlanId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    subscriptionAmount: '',
    subscriptionDays: '',
    numberOfIp: '',
    numberOfDomain: '',
  });

  const token = localStorage.getItem('token');
  const urlParts = window.location.pathname.split('/');
  const lastPart = urlParts[urlParts.length - 1];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) {
      setFieldErrors((prev) => ({ ...prev, [name]: 'Please enter numeric values only.' }));
    } else {
      setFieldErrors((prev) => ({ ...prev, [name]: '' }));
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        if (urlParts.length >= 3 && lastPart) {
          setCustomPlanId(lastPart);

          const config = {
            headers: { Authorization: `Bearer ${token}` },
          };

          const { data } = await axios.get(
            `${API_BASE_URL}/getAllContactSalesData`,
            config
          );

          const matchingData = data.data.find((item) => item._id === lastPart);

          if (matchingData) {
            setUserId(matchingData.userId);
            setSubscriptionPlanId(matchingData.subsciptionPlanId);
          }
        } else {
          toast.error('Invalid URL format.');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUser();
  }, [lastPart, token]);

  const handleSaveCustomization = (e) => {
    e.preventDefault();
    const hasErrors = Object.values(fieldErrors).some((err) => err !== '');
    if (hasErrors) {
      toast.error('Please fix the errors before submitting.');
      return;
    }
    setIsConfirmationDialogOpen(true);
  };

  const handleConfirmCustomize = async () => {
    setIsConfirmationDialogOpen(false);
    setIsLoading(true);
    try {
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };

      const payload = {
        ...formData,
        customPlanId,
        userId,
        subsciptionPlanId,
      };

      const response = await axios.post(
        `${API_BASE_URL}/createCustomizedPlansThroughAdmin`,
        payload,
        config
      );

      toast.success(response.data.message);
      closeForm();
      reloadData();
    } catch (error) {
      console.error('Error submitting form data:', error);
      toast.error('An error occurred while submitting the form.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Customize
        </Typography>

        <form onSubmit={handleSaveCustomization}>
          <Grid container spacing={2}>
            {[
              { label: 'Subscription Amount', name: 'subscriptionAmount' },
              { label: 'Subscription Days', name: 'subscriptionDays' },
              { label: 'Number of IP', name: 'numberOfIp' },
              { label: 'Number of Domain', name: 'numberOfDomain' },
            ].map((field) => (
              <Grid item xs={12} key={field.name}>
                <TextField
                  label={field.label}
                  variant="outlined"
                  fullWidth
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  error={fieldErrors[field.name] !== ''}
                  helperText={fieldErrors[field.name]}
                  required
                />
              </Grid>
            ))}
          </Grid>
          <DialogActions sx={{ justifyContent: 'center', my: 3 }}>
            {isLoading ? (
              <CircularProgress />
            ) : (
              <Box display="flex" gap={2}>
                <Button variant="contained" type="submit" color="primary">
                  Submit
                </Button>
                <Button variant="outlined" color="error" onClick={closeForm}>
                  Cancel
                </Button>
              </Box>
            )}
          </DialogActions>
        </form>
      </Container>

      <ConfirmationDialog
        isOpen={isConfirmationDialogOpen}
        onClose={() => setIsConfirmationDialogOpen(false)}
        onConfirm={handleConfirmCustomize}
        title="Customize Plan Confirmation"
        message="Are you sure you want to customize the plan for this user?"
      />
    </Card>
  );
}

export default CustomizePlan;
